import React from 'react';
import { motion } from 'framer-motion';
const categories = [{
  title: 'Cachorros',
  count: 30,
  type: 'Perro',
  color: 'bg-earth-amber/10 text-earth-amber border-earth-amber/20'
}, {
  title: 'Adultos',
  count: 30,
  type: 'Perro',
  color: 'bg-earth-amber/10 text-earth-amber border-earth-amber/20'
}, {
  title: 'Senior',
  count: 30,
  type: 'Perro',
  color: 'bg-earth-amber/10 text-earth-amber border-earth-amber/20'
}, {
  title: 'Cachorros',
  count: 30,
  type: 'Gato',
  color: 'bg-earth-green/10 text-earth-green border-earth-green/20'
}, {
  title: 'Adultos',
  count: 30,
  type: 'Gato',
  color: 'bg-earth-green/10 text-earth-green border-earth-green/20'
}, {
  title: 'Senior',
  count: 30,
  type: 'Gato',
  color: 'bg-earth-green/10 text-earth-green border-earth-green/20'
}];
export function RecipesBreakdown() {
  return <section className="py-12 md:py-24 bg-dark-800" data-id="element-89">
      <div className="container mx-auto px-6" data-id="element-90">
        <div className="text-center mb-16" data-id="element-91">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-92">
            180 Recetas Variadas
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-93">
            Diseñadas para aportar energía, digestibilidad y equilibrio
            nutricional en cada etapa de su vida.
          </motion.p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-6xl mx-auto" data-id="element-94">
          {categories.map((cat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-6 rounded-xl border ${cat.color} flex flex-col items-center justify-center text-center`} data-id="element-95">
              <span className="text-4xl font-bold mb-2" data-id="element-96">{cat.count}</span>
              <span className="text-sm uppercase tracking-wider font-semibold opacity-80 mb-1" data-id="element-97">
                {cat.type}
              </span>
              <span className="text-lg font-serif text-white" data-id="element-98">{cat.title}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}